/* eslint-disable */
// THIS FILE WAS GENERATED BY TRANSLATIONS-CLI ON Thu Apr 30 2020 19:30:13 GMT+0100 (Western European Summer Time) 
// DO NOT MODIFY DIRECTLY.
 
export default {
  "common": {
    "base_url": "https://loandolphin.com.au",
    "error": {
      "are_you_lost": "Are you lost?",
      "back_home": "Take me home",
      "enquiry_not_found": "Enquiry not found!",
      "generic": "Oops! Something went wrong, please try again later.",
      "not_found": "Page not found!",
      "oops": "Oops",
      "recaptcha": "Sorry, you seem to be a robot. If you're a real person please try again."
    },
    "external_route": {
      "about_us": "About us",
      "blog": "Blog",
      "calculators": "Calculators",
      "contact": "Contact us",
      "faq": "FAQs",
      "home": "loandolphin.com.au",
      "need_help": "Need help?",
      "terms": "Terms & Conditions"
    },
    "footer": {
      "address": "Address",
      "broker_associations": "Registered with",
      "copyright": "LoanDolphin © 2019",
      "licence": "Australian Credit Licence Number: 500703",
      "main_1": "We are not a credit provider and, in giving you product information, we are not making any suggestions or recommendations to you about a particular product.",
      "main_2": "If you decide to apply for a product, you will deal directly with a financial institution or broker and not with LoanDolphin.",
      "main_3": "Product information should be confirmed with the relevant providers (Bank Lenders and Brokers) and you should review the PDS (attached to your offer) before you decide.",
      "main_4": "This advice is general in nature and has not taken into account your objectives, financial situation or needs.",
      "main_5": "Consider whether this advice is right for you.",
      "subscribe": {
        "action": "Subscribe",
        "error": "Something went wrong! Please try again later.",
        "label": "Subscribe to our newsletter",
        "success": "We have emailed you a link to confirm your subscription. Please confirm this by clicking the link in our email."
      }
    },
    "header": {
      "about_us": "About us",
      "blog": "Blog",
      "calculators": "Calculators",
      "contact": "Contact",
      "get_started": "Get Started",
      "home": "Home",
      "how_it_works": "How it works",
      "login": "Log in"
    },
    "label": {
      "today": "Today"
    },
    "week_days": {
      "full": {
        "friday": "Friday",
        "monday": "Monday",
        "saturday": "Saturday",
        "sunday": "Sunday",
        "thursday": "Thursday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday"
      },
      "short": {
        "friday": "Fri",
        "monday": "Mon",
        "saturday": "Sat",
        "sunday": "Sun",
        "thursday": "Thu",
        "tuesday": "Tue",
        "wednesday": "Wed"
      }
    }
  },
  "home": {
    "awards": {
      "title": "Our award nominations"
    },
    "contact": {
      "action": "Send message",
      "email": "Email",
      "error": "Sorry, we weren't able to proccess your request at this time. Please verify your information or try again later.",
      "message": "Message",
      "name": "Name",
      "recaptcha": "Please tick the box to continue",
      "subject": "Topic",
      "success_1": "Thank you for contacting LoanDolphin.",
      "success_2": "Your request will be followed up by one of our team members as soon as possible.",
      "success_3": "Please make sure your spam filter is set to accept messages from loandolphin.com.au.",
      "title": "Want to get in touch with us?",
      "error_email": "Please enter a valid email.",
      "error_required": "This field is required."
    },
    "hero": {
      "subtitle": "One of the perks of working for Smartgroup is that you can save money too! Watch the banks and mortgage brokers compete for your home loan through our partnership with LoanDolphin!",
      "title": "You help customers save money, now we help you"
    },
    "demo": {
      "disclaimer": "* For illustration purposes only, not real offers"
    },
    "lenders": {
      "title": "Some of the many lenders we can access"
    },
    "numbers": {
      "average_score": {
        "description_1": "Average score from",
        "description_2": "Product Review",
        "title": "4.9/5"
      },
      "average_time": {
        "description_1": "Average time saved",
        "description_2": "per customer",
        "title": "8h"
      },
      "investment_loans": {
        "description_1": "Interest rate for",
        "description_2": "investment loans",
        "prepend": "As low as",
        "title": "2.99%"
      },
      "owner_loans": {
        "description_1": "Interest rate for",
        "description_2": "owner occupied loans",
        "prepend": "As low as",
        "title": "2.79%"
      },
      "title": "Numbers you can trust"
    },
    "outdated_browser": {
      "action": {
        "acknowledge": "Got it!",
        "new_browser": "Get a new browser"
      },
      "modal": {
        "greeting": "Ahoy there, sailor!",
        "message": "You are navigating uncharted waters and your browser is not currently supported. Please make sure to use Edge, Chrome, Firefox or Safari for some smooth sailing, otherwise, you will encounter some stormy weather ahead and our platform may not work as expected.",
        "title": "Warning"
      }
    },
    "reasons": {
      "description": "We strive to provide the best digital home loan service in Australia. Our focus is you, we want to help you get connected with the best deal you can and ultimately create a fair and transparent financial marketplace for all Australians. These are our core values.",
      "fair_and_open": {
        "description": "Unlike other sites, we don’t charge banks and brokers any joining or monthly fees. Everyone is free to compete for your home loan.",
        "title": "Fair and Open"
      },
      "free": {
        "description": "We can keep the service free thanks to our ability to attract borrowers who are serious about refinancing or looking for mortgage options for a new purchase through our unique service.",
        "title": "100% Free"
      },
      "no_obligation": {
        "description": "No commitment and you are not locked in until the loan settles. You choose what is right for you.",
        "title": "No Obligation"
      },
      "quality": {
        "description": "Each broker and lender is screened before receiving our approval. They are also reviewed and rated regularly by customers.",
        "title": "Quality Ensured"
      },
      "save_time": {
        "description": "When banks and brokers compete, you win with a better home loan in less time.",
        "title": "Save Time and Money"
      },
      "secure": {
        "description": "We use bank-grade security technology and allow you to control who sees your information.",
        "title": "Private and Secure"
      },
      "title": "Why you will love us"
    },
    "title": {
      "main": "LoanDolphin & Smartgroup"
    },
    "tutorial": {
      "label": {
        "video": "Watch a quick one-minute video"
      },
      "step_1": {
        "description": "Start by completing our enquiry form where you tell us about your priorities and financial requirements. It only takes four minutes and we assure you all of these details will remain secure and private in our platform.",
        "title": "1"
      },
      "step_2": {
        "description": "It’s just like an auction, but you’re holding the hammer. Our verified lenders compete against each other to give you the best deal on the market. Now you only have to choose, knowing that you have all the information and control, always with full transparency.",
        "title": "2"
      },
      "step_3": {
        "description": "Once you’re happy, you’ll be connected with the lender or broker you’ve selected who will support you through your application process.",
        "title": "3"
      },
      "step_4": {
        "description": "You can check the process and updates anytime, anywhere. We, LoanDolphin, will always be with you every step of the way, so step back and enjoy the ride.",
        "title": "4"
      },
      "title": "How does it work?"
    },
    "reviews": {
      "title": "Why we do it",
      "review_link_title": "Review link",
      "review1": {
        "content": "LoanDolphin exceeded our expectations. The service was so professional and accommodating. They found us a super competitive rate that we were unable to find elsewhere.",
        "author": "Annie Le Cavalier"
      },
      "review2": {
        "content": "Great support, quick responses. I had my first offer within an hour. Brokers have reviews and experience ratings which allow to judge the quality of the future engagement.",
        "author": "George"
      },
      "review3": {
        "content": "Great service. Received lots of offers to choose from and to further enquiry with if required. Currently progressing an application which looks promising which should save me a reasonable amount of costs per year.",
        "author": "Greg"
      },
      "review4": {
        "content": "The level of service I received from the team at LoanDolphin was excellent. They would get back to my questions in the same day. I felt comfortable every step of the way. I highly recommend this platform to anyone.",
        "author": "Matt K"
      },
      "review5": {
        "content": "LoanDolphin were very helpful in helping us find a better deal when we decided to refinance our home loan. Their platform is easy to use and put us in touch with some great offers.",
        "author": "Michael L"
      },
      "review6": {
        "content": "I highly recommend this platform to those looking to get a new home loan or refinance. LoanDolphin has helped me save a lot of time and hopefully a lot of money.",
        "author": "Curt"
      },
      "review7": {
        "content": "Loan Dolphin was extremely quick to match us with suitable mortgage brokers. The service provided by the mortgage broker was very professional and friendly. They went above and beyond to get us a great deal to buy our first home.",
        "author": "Nathan M"
      }
    },
    "story": {
      "title": "The story behind our business",
      "paragraph_1": "LoanDolphin was born when founders Ranin Mendis and Rod Dutra met while working in a ‘Big 4’ bank. They saw the hassle and frustration customers often experienced in securing the right loan at the best rate. They knew there had to be a better way. A way to make the process transparent and fair to ensure customers conveniently received access to the right loan.",
      "paragraph_2": "LoanDolphin is the only truly customer-centric digital loan service that helps you get interest rates lower than advertised. We are not affiliated with any one bank or mortgage broker and remain focused on creating a transparent financial marketplace for all Australians."
    },
    "alternate": {
      "accesspay": {
        "title": "Get a mortgage health check online in just a few minutes thanks to AccessPay",
        "subtitle": "One of the perks of being an AccessPay customer is that you could save money on your mortgage too! Watch the banks and mortgage brokers compete for your home loan through our partnership with LoanDolphin!"
      },
      "advantage": {
        "title": "Get a mortgage health check online in just a few minutes thanks to Advantage",
        "subtitle": "One of the perks of being an Advantage Salary Packaging customer is that you could save money on your mortgage too! Watch the banks and mortgage brokers compete for your home loan through our partnership with LoanDolphin!"
      },
      "smartsalary": {
        "title": "Get a mortgage health check online in just a few minutes thanks to Smartsalary",
        "subtitle": "One of the perks of being a Smartsalary customer is that you could save money on your mortgage too! Watch the banks and mortgage brokers compete for your home loan through our partnership with LoanDolphin!"
      },
      "autopia": {
        "title": "Get a mortgage health check online in just a few minutes thanks to Autopia",
        "subtitle": "One of the perks of being an Autopia customer is that you could save money on your mortgage too! Watch the banks and mortgage brokers compete for your home loan through our partnership with LoanDolphin!"
      },
      "smartleasing": {
        "title": "Get a mortgage health check online in just a few minutes thanks to Smartleasing",
        "subtitle": "One of the perks of being a Smartleasing customer is that you could save money on your mortgage too! Watch the banks and mortgage brokers compete for your home loan through our partnership with LoanDolphin!"
      },
      "selectus": {
        "title": "Get a mortgage health check online in just a few minutes thanks to Selectus",
        "subtitle": "One of the perks of being a Selectus customer is that you could save money on your mortgage too! Watch the banks and mortgage brokers compete for your home loan through our partnership with LoanDolphin!"
      }
    }
  }
}